import styled from "styled-components";
import { Form, Nav, NavItem, Table } from "react-bootstrap";

interface INavProps {
    tabWidth?: string,
    fontSize?: string
}

export const NavWrapper = styled(Nav) <INavProps>`
    & > li {
        margin-bottom: -2px;
    }
    
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
    }

    & > li > a {
        width: ${(p: INavProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
        font-size: ${(p: INavProps) => p.fontSize ? p.fontSize + ' !important' : '16px'};
    }
`;

interface IPillWrapperProps {
    verticalAlign?: string,
    // minTabWidth?: string,
    //fontSize?: string
    isBigScreen: boolean
}

export const PillWrapper = styled(Nav) <IPillWrapperProps>`
    // & > li {
    //     height: 52px;
    // }

    & > .center-profile-tabs > li {
        height: 48px;
    }

    & > .center-profile-tabs > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #337ab7;
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: IPillWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        // min-width: ${(p: IPillWrapperProps) => p.isBigScreen ? '230px !important' : '200px'};
    }

    & > .center-profile-tabs > li.active > a {
        color: #555;
        background-color: #fff;
    }

    & > div > .center-profile-pills > li > a {
        padding: 5px 7px;
        font-size: ${(p: IPillWrapperProps) => p.isBigScreen ? '14px !important' : '13px'};
    }

    & > div > .center-profile-pills > li.admin > a {
        color: orange;
        font-weight: 700;
    }

    & > div > .center-profile-pills > li.admin.active > a {
        color: #fff;
        background-color: orange;
    }

    & > div > .center-profile-pills > li > span {
        position: relative;
        display: block;
        font-size: 12px;
        padding: 5px 7px;
        color: #ccc;
    }

    & > div > .center-profile-pills > li > div.pill-divider {
        margin-left: ${(p: IPillWrapperProps) => p.isBigScreen ? '3px' : '1px'};
        margin-right: ${(p: IPillWrapperProps) => p.isBigScreen ? '3px' : '1px'};
        margin-top: 9px;
        height: 10px;
        width: 1px;
        background-color: #ccc;
        // border: 0.5px solid #ccc
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            font-size: 12px;
            // min-width: 120px;
        }
    }
`;

interface INavItemProps {
    tabWidth?: string,
    fontSize?: string
}

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    //     font-size: ${(p: INavItemProps) => p.fontSize ? p.fontSize + ' !important' : '16px'};
    // }

    & > a {
        // width: 300px;
    }
`;

export const GridWrapper = styled.div<{ width?: string, height?: string, headerBgColor?: string, headerFontColor?: string, headerFontWeight?: number }>`
    width: ${p => p.width ? p.width : '87%'};
    height: ${p => p.height ? p.height : '80vh'};

    .action-menu {
        overflow: visible;
        // border-bottom: none;
        line-height: 25px;
        // border-color: #ccc;
        display: flex;
        align-items: center;
        // padding-left: 0px;
        // padding-right: 0px;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu > .ag-react-container > div > .btn-group {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        // border-top: 1px solid #ccc !important;
        // border-right: 1px solid white !important;
        // border-bottom: 1px solid white !important;
        // border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: ${p => p.headerBgColor ? p.headerBgColor : '#123'};
        color: ${p => p.headerFontColor ? p.headerFontColor : 'white'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: ${p => p.headerFontWeight ? p.headerFontWeight : 400};
    }

    .ag-cell {
        // border-right-color: black !important;
        // border-right-width: 1px !important;
        // border-right-style: solid !important;
    }

    .ag-header-cell,  .ag-header-group-cell {
        // border-right: 1px solid black !important;
    }

    // .ag-header-cell::after {
    //     border-right: 1px solid #ccc;
    //     content: " ";
    //     height: 16px;
    //     margin-top: 4px;
    //     position: absolute;
    //     text-indent: -2000px;
    //     top: 0;
    //     right: 0;
    // }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-hover {
        // background-color: #ddd;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
    }

    .center-list-cell-highlight {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        // border-color: #ccc;
        // font-size: 12px;
        background-color: yellow;
    }

    .center-list-header {
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // padding-bottom: 4px;
    }

    .center-list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }
`;

export const ContainerWrapper = styled.div`
    padding: 0px 10px;

    .center-profile-section {
        padding: 20px;
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #ddd;
        border-radius: 4px;
        background-color: #FFF;
    }

    .form-group {
        margin-bottom: 7px;
    }

    .form-group > .col-xs-12.col-sm-6 > .control-label {
        margin: 0;
    }
`;

interface IFormWrapperProps { noStripe?: boolean }

export const FormWrapper = styled(Form) <IFormWrapperProps>`
    .help-block {
        font-size: 12px;
        margin-bottom: 0px;
    }

    .control-label {
        // text-align: left;
    }
`;

export const TableWrapper = styled(Table)`
    margin-bottom: 0px;
    
    & > tbody > tr > td {
        vertical-align: middle;
        text-align: right;
        border-top: 0 none;
    }
`;

export const ContentWrapper = styled.div`
    padding: 20px;
    border-width: 1px 1px 1px 1px;
    border-style: solid;
    border-color: #ddd;
    border-radius: 4px;
`;